import minusZeroImg from '@/assets/images/minus_zero1.webp'
import Translatable from '../translatable_text/Translatable';

function Services() {
  return (
<section className="portfolio-tab crev py-16 md:py-24" data-scroll-index="3" >
  <div className="max-w-7xl mx-auto px-4">
    <div className="sec-head mb-80 d-rotate wow">
      <h2 className="sub-title main-color mb-25">
        <span className="rotate-text">
          <Translatable>GCAD</Translatable> <span className="fw-100"><Translatable>Services</Translatable></span>
        </span>
      </h2>
      <div className="bord pt-25 bord-thin-top flex items-center justify-between">
        <h2 className="ltr:hidden fw-600 text-4xl">
          <span className="rotate-text">
            <Translatable>خدمات</Translatable> <span className="fw-200"><Translatable>جكاد</Translatable></span>
          </span>
        </h2>
        <h2 className="rtl:hidden fw-600 text-5xl d-rotate wow uppercase">
          <span className="rotate-text">
            <Translatable>GCAD</Translatable> <span className="fw-100"><Translatable>Services</Translatable></span>
          </span>
        </h2>
        <div className='flex items-center justify-center'>
          <a href="/contact" aria-label='go to join' className="go-more flex items-center gap-3">
            <span className="text underline">
              <Translatable>Contact us</Translatable>
            </span>
            <img src="/light/assets/imgs/arrow-right.webp" alt="icon" loading='lazy' className="icon-img-20 ml-5 -mr-1" width="40px" height="40px" />
          </a>
        </div>
      </div>
    </div>
    <div className="flex flex-wrap flex-row-reverse justify-between pt-80 d-rotate wow">
      <div className="w-full lg:w-5/12 px-4 flex items-center justify-center">
        <div className="glry-img">
          <div id="tab-1" className="bg-img tab-img current" data-background="https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" ></div>
          <div id="tab-2" className="bg-img tab-img" data-background={minusZeroImg} ></div>
          <div id="tab-3" className="bg-img tab-img" data-background="https://images.unsplash.com/photo-1544890225-2f3faec4cd60?q=80&w=1925&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" ></div>
          <div id="tab-4" className="bg-img tab-img" data-background="https://www.bbva.com/wp-content/uploads/2020/12/blockchain-1024x629.jpg" ></div>
        </div>
      </div>
      <div className="w-full lg:w-6/12 lg:ml-[8.333333%]x px-4 content">
        <div className="cluom my-12 rotate-text current" data-tab="tab-1">
          <div className="info">
            <h6 className="sub-title opacity-70"><Translatable>Development & Encryption</Translatable></h6>
            <h4><Translatable>Project Development</Translatable></h4>
          </div>
          <div className="img">
            <img src={"https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"} alt="image" loading='lazy'/>
          </div>
          <div className="morex uppercase tracking-wider text-xs">
            <a href="/services/development-encryption" className='flex gap-3 items-center'>
              <Translatable>View Service</Translatable> <i className="ml-4 ti-arrow-top-right"></i>
            </a>
          </div>
        </div>
        <div className="cluom my-12 rotate-text" data-tab="tab-2">
          <div className="info">
            <h6 className="sub-title opacity-70"><Translatable>AI Unit</Translatable></h6>
            <h4><Translatable>Artificial intelligence</Translatable></h4>
          </div>
          <div className="img">
            <img src={minusZeroImg} alt="image" loading='lazy'/>
          </div>
          <div className="morex uppercase tracking-wider text-xs">
            <a href="/services/artificial-intelligence" className='flex gap-3 items-center'>
              <Translatable>View Units</Translatable> <i className="ml-4 ti-arrow-top-right"></i>
            </a>
          </div>
        </div>
        <div className="cluom my-12 rotate-text" data-tab="tab-3">
          <div className="info">
            <h6 className="sub-title opacity-70"><Translatable>Consultation services</Translatable></h6>
            <h4><Translatable>Consultation</Translatable></h4>
          </div>
          <div className="img">
            <img src="https://images.unsplash.com/photo-1544890225-2f3faec4cd60?q=80&w=1925&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="image" loading='lazy'/>
          </div>
          <div className="morex uppercase tracking-wider text-xs">
            <a href="/services/consultations" className='flex gap-3 items-center'>
              <Translatable>More Details</Translatable> <i className="ml-4 ti-arrow-top-right"></i>
            </a>
          </div>
        </div>
        {/* <div className="cluom my-12 rotate-text" data-tab="tab-4">
          <div className="info">
            <h6 className="sub-title opacity-70"><Translatable>Digital Assets</Translatable></h6>
            <h4><Translatable>Digital Assets</Translatable></h4>
          </div>
          <div className="img">
            <img src="https://www.bbva.com/wp-content/uploads/2020/12/blockchain-1024x629.jpg" alt="image" loading='lazy'/>
          </div>
          <div className="morex uppercase tracking-wider text-xs">
            <a href="/services/digital-assets" className='flex gap-3 items-center'>
              <Translatable>View Assets</Translatable> <i className="ml-4 ti-arrow-top-right"></i>
            </a>
          </div>
        </div> */}
      </div>
    </div>
  </div>
</section>
  );
}

export default Services;